import { Descriptions, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AudiFinancingModuleSpecsFragment } from '../../../../../api/fragments';
import AuthorizationEmpty from './AuthorizationEmpty';

export type AuthorizationProps = {
    module: AudiFinancingModuleSpecsFragment;
};

const Authorization = ({ module }: AuthorizationProps) => {
    const { t } = useTranslation('audiFinancingModuleDetails');

    if (!module.authorization) {
        return <AuthorizationEmpty module={module} />;
    }

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('audiFinancingModuleDetails:fields.authorization.accessKey.label')}>
                    {module.authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('audiFinancingModuleDetails:fields.authorization.secretKey.label')}>
                    {module.authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default Authorization;
